import React from 'react'

import EditInverted from '@scoir/brand-icons/dist/EditInverted'
import PropTypes from 'prop-types'

import './SelectedLocation.scss'

const SelectedLocation = ({ children, onEdit, canEdit }) => (
  <div className="selected-location-comp">
    <div className="children-wrapper">{children}</div>
    {canEdit && (
      <div
        className="closer"
        id="location-editor"
        tabIndex={0}
        onClick={onEdit}
        onKeyDown={(e) => (e.key === ' ' || e.keyCode === 13) && onEdit()}
      >
        <EditInverted />
      </div>
    )}
  </div>
)

SelectedLocation.propTypes = {
  children: PropTypes.any,
  onEdit: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
}

export default SelectedLocation
